import { NgModule } from "@angular/core";
import { Routes, RouterModule } from "@angular/router";
import { AuthGuard } from "./auth/auth.guard";

import { LoginComponent } from "./login/login.component";
import { PageNotFoundComponent } from "./shared/page-not-found/page-not-found.component";
import { HomeComponent } from "./home/home.component";
import { AuthComponent } from "./auth/auth.component";
import { KanbanDashboardComponent } from "./kanban-dashboard/kanban-dashboard.component";
import { OutcomeComponent } from "./outcome/outcome.component";
import { MyTasksComponent } from "./my-tasks/my-tasks.component";
import { DependenciesComponent } from "./dependencies/dependencies.component";
import { ProgressDashboardComponent } from "./progress-dashboard/progress-dashboard.component";
import { DashboardComponent } from "./work-package/dashboard/dashboard.component";
import { WpListComponent } from "./work-package/wp-list/wp-list.component";
import { DocTemplateComponent } from "./work-package/doc-template/doc-template.component";


const appRoutes: Routes = [
    {
        path: '',
        component: LoginComponent
    },
    {
        path: 'auth/callback',
        component: AuthComponent
    },
    {
        path: 'doc',
        component: DocTemplateComponent,
    },
    {
        path: 'home',
        component: HomeComponent,
        canActivate: [AuthGuard]
    },
    {
        path: 'outcomes',
        component: OutcomeComponent,
        canActivate: [AuthGuard]
    },
    {
        path: 'progress-view',
        component: ProgressDashboardComponent,
        canActivate: [AuthGuard]
    },
    {
        path: 'kanban-view',
        component: KanbanDashboardComponent,
        canActivate: [AuthGuard]
    },
    {
        path: 'myTasks',
        component: MyTasksComponent,
        canActivate: [AuthGuard]
    },
    {
        path: 'dependencies',
        component: DependenciesComponent,
        canActivate: [AuthGuard]
    },
    {
        path: 'wp/dashboard',
        component: DashboardComponent,
        canActivate: [AuthGuard]
    },
    {
        path: 'wp/document',
        component: DocTemplateComponent
    },
    {
        path: 'wp/list',
        component: WpListComponent,
        canActivate: [AuthGuard]
    },
    {
        path: 'admin',
        children: [
            {
                path: '',
                loadChildren: () => import('./admin/admin-routing.module').then(m => m.AdminRoutingModule),
                canActivate: [AuthGuard]
            },
        ],
    },
    { 
        path: 'not-found', 
        component: PageNotFoundComponent 
    },
    { 
        path: '**', 
        redirectTo: '/not-found', 
        pathMatch: 'full'  
    },
];

@NgModule({
    imports: [
        RouterModule.forRoot(appRoutes)
    ],
    exports: [RouterModule]
})
export class AppRoutingModule {}